<div class="rkt-form-field-wrapper">
  <div class="rkt-form-field" [class.has-error]="isMaximumValue || isMinimumValue || isSameValue">
    <input
      type="text"
      class="rkt-form-input"
      [class.is-invalid]="isMaximumValue || isMinimumValue || isSameValue"
      [formControl]="valueField"
      id="limitValue"
      prefix="$ "
      mask="separator.2"
      thousandSeparator=","
      placeholder="$ 0.00"
      (ngModelChange)="onChange($event)"
      (blur)="onBlur()"
    />

    @if (isMaximumValue) {
      <div class="rkt-form-field-invalid-feedback">
        Transaction amount limit must be less or equal to {{ maxLimitLabel || maxLimitsType[limitType] }}.
      </div>
    }
    @if (isMinimumValue) {
      <div class="rkt-form-field-invalid-feedback">Transaction amount limit cannot be negative</div>
    }
    @if (isSameValue) {
      <div class="rkt-form-field-invalid-feedback">The new limit must be different from the current limit</div>
    }
  </div>
</div>
